import { callServer } from './api';

let statesInIndia = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttarakhand',
    'Uttar Pradesh',
    'West Bengal',
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli',
    'Daman and Diu',
    'Delhi',
    'Lakshadweep',
    'Puducherry',
];
export { statesInIndia };

export function validateCareerForm(
    values,
    setIsPersonDataFilled,
    setIsLocationFilled,
    setIsResumeSelected,
) {
    const errors = {};

    if (!values) {
        return errors;
    }

    // Mandatory
    const requiredFields = [
        'name',
        'jobRole',
        'email',
        'phone',
        'state',
        'district',
        'education',
        'coverLetter',
        'fileName',
    ];

    requiredFields.map((field) => {
        if (values[field] === '') {
            errors[field] = 'Required';
        }
    });

    if (!values.email) {
        errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }

    // For Timeline
    const personalDataFields = ['name', 'jobRole', 'email', 'phone'];
    const locationFields = ['state', 'district'];
    const resumeField = ['fileName', 'coverLetter', 'education'];

    let isPersonalDataHasErrors = false;
    let isLocationHasErrors = false;
    let isResumeHasErrors = false;

    personalDataFields.map((field) => {
        if (errors[field]) {
            isPersonalDataHasErrors = true;
        }
    });

    locationFields.map((field) => {
        if (errors[field]) {
            isLocationHasErrors = true;
        }
    });

    resumeField.map((field) => {
        if (errors[field]) {
            isResumeHasErrors = true;
        }
    });

    isPersonalDataHasErrors
        ? setIsPersonDataFilled(false)
        : setIsPersonDataFilled(true);
    isLocationHasErrors
        ? setIsLocationFilled(false)
        : setIsLocationFilled(true);
    isResumeHasErrors ? setIsResumeSelected(false) : setIsResumeSelected(true);

    return errors;
}

export function setJobRolesInSession(jobRoles) {
    try {
        sessionStorage.setItem('jobRoles', JSON.stringify(jobRoles));
    } catch {
        // storage unavailable (e.g. blocked in-app browser) — ignore
    }
}

export function getJobRolesFromSession() {
    try {
        return JSON.parse(sessionStorage.getItem('jobRoles'));
    } catch {
        return null;
    }
}

export async function submitJobApplicationForm(payload) {
    const data = await callServer('create_job_applicant', 'POST', payload);
    return data.message;
}

export async function submitContactForm(payload) {
    const data = await callServer('create_lead', 'POST', payload);
    return data.message;
}

export async function submitWebinarForm(payload) {
    const data = await callServer(
        'webinar.register_for_webinar',
        'POST',
        payload,
    );

    if (data && (data.exc_type || data.exception)) {
        const error = new Error(
            data.exception || 'Webinar registration failed',
        );
        error.data = data;
        throw error;
    }
    return data;
}

export async function extractFileData(fileObject, callback) {
    let fileContent = '';

    const reader = new FileReader();
    reader.onloadend = () => {
        fileContent = reader.result;
        callback('fileData', fileContent);
    };
    reader.readAsDataURL(fileObject);
}

export function validateContactForm(values) {
    const errors = {};

    if (!values) {
        return errors;
    }

    // Mandatory
    const requiredFields = ['name', 'email', 'phone'];

    requiredFields.map((field) => {
        if (values[field] === '') {
            errors[field] = 'Required';
        }
    });

    return errors;
}

export const districts = {
    'Andaman and Nicobar Islands': [
        'Nicobar',
        'North and Middle Andaman',
        'South Andaman',
    ],
    'Andhra Pradesh': [
        'Anantapur',
        'Chittoor',
        'East Godavari',
        'Guntur',
        'Krishna',
        'Kurnool',
        'Nellore',
        'Prakasam',
        'Srikakulam',
        'Visakhapatnam',
        'Vizianagaram',
        'West Godavari',
        'YSR Kadapa',
    ],
    'Arunachal Pradesh': [
        'Tawang',
        'West Kameng',
        'East Kameng',
        'Papum Pare',
        'Kurung Kumey',
        'Kra Daadi',
        'Lower Subansiri',
        'Upper Subansiri',
        'West Siang',
        'East Siang',
        'Siang',
        'Upper Siang',
        'Lower Siang',
        'Lower Dibang Valley',
        'Dibang Valley',
        'Anjaw',
        'Lohit',
        'Namsai',
        'Changlang',
        'Tirap',
        'Longding',
    ],
    Assam: [
        'Baksa',
        'Barpeta',
        'Biswanath',
        'Bongaigaon',
        'Cachar',
        'Charaideo',
        'Chirang',
        'Darrang',
        'Dhemaji',
        'Dhubri',
        'Dibrugarh',
        'Goalpara',
        'Golaghat',
        'Hailakandi',
        'Hojai',
        'Jorhat',
        'Kamrup Metropolitan',
        'Kamrup',
        'Karbi Anglong',
        'Karimganj',
        'Kokrajhar',
        'Lakhimpur',
        'Majuli',
        'Morigaon',
        'Nagaon',
        'Nalbari',
        'Dima Hasao',
        'Sivasagar',
        'Sonitpur',
        'South Salmara-Mankachar',
        'Tinsukia',
        'Udalguri',
        'West Karbi Anglong',
    ],
    Bihar: [
        'Araria',
        'Arwal',
        'Aurangabad',
        'Banka',
        'Begusarai',
        'Bhagalpur',
        'Bhojpur',
        'Buxar',
        'Darbhanga',
        'East Champaran (Motihari)',
        'Gaya',
        'Gopalganj',
        'Jamui',
        'Jehanabad',
        'Kaimur (Bhabua)',
        'Katihar',
        'Khagaria',
        'Kishanganj',
        'Lakhisarai',
        'Madhepura',
        'Madhubani',
        'Munger (Monghyr)',
        'Muzaffarpur',
        'Nalanda',
        'Nawada',
        'Patna',
        'Purnia (Purnea)',
        'Rohtas',
        'Saharsa',
        'Samastipur',
        'Saran',
        'Sheikhpura',
        'Sheohar',
        'Sitamarhi',
        'Siwan',
        'Supaul',
        'Vaishali',
        'West Champaran',
    ],
    Chandigarh: ['Chandigarh'],
    Chhattisgarh: [
        'Balod',
        'Baloda Bazar',
        'Balrampur',
        'Bastar',
        'Bemetara',
        'Bijapur',
        'Bilaspur',
        'Dantewada (South Bastar)',
        'Dhamtari',
        'Durg',
        'Gariyaband',
        'Janjgir-Champa',
        'Jashpur',
        'Kabirdham (Kawardha)',
        'Kanker (North Bastar)',
        'Kondagaon',
        'Korba',
        'Korea (Koriya)',
        'Mahasamund',
        'Mungeli',
        'Narayanpur',
        'Raigarh',
        'Raipur',
        'Rajnandgaon',
        'Sukma',
        'Surajpur  ',
        'Surguja',
    ],
    'Dadra and Nagar Haveli': ['Dadra & Nagar Haveli'],
    'Daman and Diu': ['Daman', 'Diu'],
    Delhi: [
        'Central Delhi',
        'East Delhi',
        'New Delhi',
        'North Delhi',
        'North East Delhi',
        'North West Delhi',
        'Shahdara',
        'South Delhi',
        'South East Delhi',
        'South West Delhi',
        'West Delhi',
    ],
    Goa: ['North Goa', 'South Goa'],
    Gujarat: [
        'Ahmedabad',
        'Amreli',
        'Anand',
        'Aravalli',
        'Banaskantha (Palanpur)',
        'Bharuch',
        'Bhavnagar',
        'Botad',
        'Chhota Udepur',
        'Dahod',
        'Dangs (Ahwa)',
        'Devbhoomi Dwarka',
        'Gandhinagar',
        'Gir Somnath',
        'Jamnagar',
        'Junagadh',
        'Kachchh',
        'Kheda (Nadiad)',
        'Mahisagar',
        'Mehsana',
        'Morbi',
        'Narmada (Rajpipla)',
        'Navsari',
        'Panchmahal (Godhra)',
        'Patan',
        'Porbandar',
        'Rajkot',
        'Sabarkantha (Himmatnagar)',
        'Surat',
        'Surendranagar',
        'Tapi (Vyara)',
        'Vadodara',
        'Valsad',
    ],
    Haryana: [
        'Ambala',
        'Bhiwani',
        'Charkhi Dadri',
        'Faridabad',
        'Fatehabad',
        'Gurugram (Gurgaon)',
        'Hisar',
        'Jhajjar',
        'Jind',
        'Kaithal',
        'Karnal',
        'Kurukshetra',
        'Mahendragarh',
        'Nuh',
        'Palwal',
        'Panchkula',
        'Panipat',
        'Rewari',
        'Rohtak',
        'Sirsa',
        'Sonipat',
        'Yamunanagar',
    ],
    'Himachal Pradesh': [
        'Bilaspur',
        'Chamba',
        'Hamirpur',
        'Kangra',
        'Kinnaur',
        'Kullu',
        'Lahaul & Spiti',
        'Mandi',
        'Shimla',
        'Sirmaur (Sirmour)',
        'Solan',
        'Una',
    ],
    'Jammu and Kashmir': [
        'Anantnag',
        'Bandipore',
        'Baramulla',
        'Budgam',
        'Doda',
        'Ganderbal',
        'Jammu',
        'Kathua',
        'Kishtwar',
        'Kulgam',
        'Kupwara',
        'Poonch',
        'Pulwama',
        'Rajouri',
        'Ramban',
        'Reasi',
        'Samba',
        'Shopian',
        'Srinagar',
        'Udhampur',
    ],
    Jharkhand: [
        'Bokaro',
        'Chatra',
        'Deoghar',
        'Dhanbad',
        'Dumka',
        'East Singhbhum',
        'Garhwa',
        'Giridih',
        'Godda',
        'Gumla',
        'Hazaribag',
        'Jamtara',
        'Khunti',
        'Koderma',
        'Latehar',
        'Lohardaga',
        'Pakur',
        'Palamu',
        'Ramgarh',
        'Ranchi',
        'Sahibganj',
        'Seraikela-Kharsawan',
        'Simdega',
        'West Singhbhum',
    ],
    Karnataka: [
        'Bagalkot',
        'Ballari (Bellary)',
        'Belagavi (Belgaum)',
        'Bengaluru (Bangalore) Rural',
        'Bengaluru (Bangalore) Urban',
        'Bidar',
        'Chamarajanagar',
        'Chikballapur',
        'Chikkamagaluru (Chikmagalur)',
        'Chitradurga',
        'Dakshina Kannada',
        'Davangere',
        'Dharwad',
        'Gadag',
        'Hassan',
        'Haveri',
        'Kalaburagi (Gulbarga)',
        'Kodagu',
        'Kolar',
        'Koppal',
        'Mandya',
        'Mysuru (Mysore)',
        'Raichur',
        'Ramanagara',
        'Shivamogga (Shimoga)',
        'Tumakuru (Tumkur)',
        'Udupi',
        'Uttara Kannada (Karwar)',
        'Vijayapura (Bijapur)',
        'Yadgir',
    ],
    Kerala: [
        'Alappuzha',
        'Ernakulam',
        'Idukki',
        'Kannur',
        'Kasaragod',
        'Kollam',
        'Kottayam',
        'Kozhikode',
        'Malappuram',
        'Palakkad',
        'Pathanamthitta',
        'Thiruvananthapuram',
        'Thrissur',
        'Wayanad',
    ],
    Lakshadweep: [
        'Agatti',
        'Amini',
        'Androth',
        'Bithra',
        'Chethlath',
        'Kavaratti',
        'Kadmath',
        'Kalpeni',
        'Kilthan',
        'Minicoy',
    ],
    'Madhya Pradesh': [
        'Agar Malwa',
        'Alirajpur',
        'Anuppur',
        'Ashoknagar',
        'Balaghat',
        'Barwani',
        'Betul',
        'Bhind',
        'Bhopal',
        'Burhanpur',
        'Chhatarpur',
        'Chhindwara',
        'Damoh',
        'Datia',
        'Dewas',
        'Dhar',
        'Dindori',
        'Guna',
        'Gwalior',
        'Harda',
        'Hoshangabad',
        'Indore',
        'Jabalpur',
        'Jhabua',
        'Katni',
        'Khandwa',
        'Khargone',
        'Mandla',
        'Mandsaur',
        'Morena',
        'Narsinghpur',
        'Neemuch',
        'Panna',
        'Raisen',
        'Rajgarh',
        'Ratlam',
        'Rewa',
        'Sagar',
        'Satna',
        'Sehore',
        'Seoni',
        'Shahdol',
        'Shajapur',
        'Sheopur',
        'Shivpuri',
        'Sidhi',
        'Singrauli',
        'Tikamgarh',
        'Ujjain',
        'Umaria',
        'Vidisha',
    ],
    Maharashtra: [
        'Ahmednagar',
        'Akola',
        'Amravati',
        'Aurangabad',
        'Beed',
        'Bhandara',
        'Buldhana',
        'Chandrapur',
        'Dhule',
        'Gadchiroli',
        'Gondia',
        'Hingoli',
        'Jalgaon',
        'Jalna',
        'Kolhapur',
        'Latur',
        'Mumbai City',
        'Mumbai Suburban',
        'Nagpur',
        'Nanded',
        'Nandurbar',
        'Nashik',
        'Osmanabad',
        'Palghar',
        'Parbhani',
        'Pune',
        'Raigad',
        'Ratnagiri',
        'Sangli',
        'Satara',
        'Sindhudurg',
        'Solapur',
        'Thane',
        'Wardha',
        'Washim',
        'Yavatmal',
    ],
    Manipur: [
        'Bishnupur',
        'Chandel',
        'Churachandpur',
        'Imphal East',
        'Imphal West',
        'Jiribam',
        'Kakching',
        'Kamjong',
        'Kangpokpi',
        'Noney',
        'Pherzawl',
        'Senapati',
        'Tamenglong',
        'Tengnoupal',
        'Thoubal',
        'Ukhrul',
    ],
    Meghalaya: [
        'East Garo Hills',
        'East Jaintia Hills',
        'East Khasi Hills',
        'North Garo Hills',
        'Ri Bhoi',
        'South Garo Hills',
        'South West Garo Hills',
        'South West Khasi Hills',
        'West Garo Hills',
        'West Jaintia Hills',
        'West Khasi Hills',
    ],
    Mizoram: [
        'Aizawl',
        'Champhai',
        'Hnahthial',
        'Khawzawl',
        'Kolasib',
        'Lawngtlai',
        'Lunglei',
        'Mamit',
        'Saiha',
        'Saitual',
        'Serchhip',
    ],
    Nagaland: [
        'Dimapur',
        'Kiphire',
        'Kohima',
        'Longleng',
        'Mokokchung',
        'Mon',
        'Peren',
        'Phek',
        'Tuensang',
        'Wokha',
        'Zunheboto',
    ],
    Odisha: [
        'Angul',
        'Balangir',
        'Balasore',
        'Bargarh',
        'Bhadrak',
        'Boudh',
        'Cuttack',
        'Deogarh',
        'Dhenkanal',
        'Gajapati',
        'Ganjam',
        'Jagatsinghapur',
        'Jajpur',
        'Jharsuguda',
        'Kalahandi',
        'Kandhamal',
        'Kendrapara',
        'Kendujhar (Keonjhar)',
        'Khordha',
        'Koraput',
        'Malkangiri',
        'Mayurbhanj',
        'Nabarangpur',
        'Nayagarh',
        'Nuapada',
        'Puri',
        'Rayagada',
        'Sambalpur',
        'Subarnapur (Sonepur)',
        'Sundargarh',
    ],
    Puducherry: ['Karaikal', 'Mahe', 'Puducherry', 'Yanam'],
    Punjab: [
        'Amritsar',
        'Barnala',
        'Bathinda',
        'Faridkot',
        'Fatehgarh Sahib',
        'Fazilka',
        'Ferozepur',
        'Gurdaspur',
        'Hoshiarpur',
        'Jalandhar',
        'Kapurthala',
        'Ludhiana',
        'Mansa',
        'Moga',
        'Muktsar',
        'Pathankot',
        'Patiala',
        'Rupnagar',
        'Sahibzada Ajit Singh Nagar (Mohali)',
        'Sangrur',
        'Shaheed Bhagat Singh Nagar (Nawanshahr)',
        'Sri Muktsar Sahib',
        'Tarn Taran',
    ],
    Rajasthan: [
        'Ajmer',
        'Alwar',
        'Banswara',
        'Baran',
        'Barmer',
        'Bharatpur',
        'Bhilwara',
        'Bikaner',
        'Bundi',
        'Chittorgarh',
        'Churu',
        'Dausa',
        'Dholpur',
        'Dungarpur',
        'Hanumangarh',
        'Jaipur',
        'Jaisalmer',
        'Jalore',
        'Jhalawar',
        'Jhunjhunu',
        'Jodhpur',
        'Karauli',
        'Kota',
        'Nagaur',
        'Pali',
        'Pratapgarh',
        'Rajsamand',
        'Sawai Madhopur',
        'Sikar',
        'Sirohi',
        'Sri Ganganagar',
        'Tonk',
        'Udaipur',
    ],
    Sikkim: ['East Sikkim', 'North Sikkim', 'South Sikkim', 'West Sikkim'],
    'Tamil Nadu': [
        'Ariyalur',
        'Chengalpattu',
        'Chennai',
        'Coimbatore',
        'Cuddalore',
        'Dharmapuri',
        'Dindigul',
        'Erode',
        'Kallakurichi',
        'Kanchipuram',
        'Kanyakumari',
        'Karur',
        'Krishnagiri',
        'Madurai',
        'Mayiladuthurai',
        'Nagapattinam',
        'Namakkal',
        'Nilgiris',
        'Perambalur',
        'Pudukkottai',
        'Ramanathapuram',
        'Ranipet',
        'Salem',
        'Sivaganga',
        'Tenkasi',
        'Thanjavur',
        'Theni',
        'Thoothukudi',
        'Tiruchirappalli',
        'Tirunelveli',
        'Tirupathur',
        'Tiruppur',
        'Tiruvallur',
        'Tiruvannamalai',
        'Tiruvarur',
        'Vellore',
        'Viluppuram',
        'Virudhunagar',
    ],
    Telangana: [
        'Adilabad',
        'Bhadradri Kothagudem',
        'Hyderabad',
        'Jagtial',
        'Jangaon',
        'Jayashankar Bhupalpally',
        'Jogulamba Gadwal',
        'Kamareddy',
        'Karimnagar',
        'Khammam',
        'Komaram Bheem',
        'Mahabubabad',
        'Mahabubnagar',
        'Mancherial',
        'Medak',
        'Medchal',
        'Nagarkurnool',
        'Nalgonda',
        'Nirmal',
        'Nizamabad',
        'Peddapalli',
        'Rajanna Sircilla',
        'Rangareddy',
        'Sangareddy',
        'Siddipet',
        'Suryapet',
        'Vikarabad',
        'Wanaparthy',
        'Warangal (Rural)',
        'Warangal (Urban)',
        'Yadadri Bhuvanagiri',
    ],
    Tripura: [
        'Dhalai',
        'Gomati',
        'Khowai',
        'North Tripura',
        'Sepahijala',
        'South Tripura',
        'Unakoti',
        'West Tripura',
    ],
    Uttarakhand: [
        'Almora',
        'Bageshwar',
        'Chamoli',
        'Champawat',
        'Dehradun',
        'Haridwar',
        'Nainital',
        'Pauri Garhwal',
        'Pithoragarh',
        'Rudraprayag',
        'Tehri Garhwal',
        'Udham Singh Nagar',
        'Uttarkashi',
    ],
    'Uttar Pradesh': [
        'Agra',
        'Aligarh',
        'Allahabad',
        'Ambedkar Nagar',
        'Amethi (Chatrapati Sahuji Mahraj Nagar)',
        'Amroha (J.P. Nagar)',
        'Auraiya',
        'Azamgarh',
        'Baghpat',
        'Bahraich',
        'Ballia',
        'Balrampur',
        'Banda',
        'Barabanki',
        'Bareilly',
        'Basti',
        'Bhadohi',
        'Bijnor',
        'Budaun',
        'Bulandshahr',
        'Chandauli',
        'Chitrakoot',
        'Deoria',
        'Etah',
        'Etawah',
        'Faizabad',
        'Farrukhabad',
        'Fatehpur',
        'Firozabad',
        'Gautam Buddha Nagar',
        'Ghaziabad',
        'Ghazipur',
        'Gonda',
        'Gorakhpur',
        'Hamirpur',
        'Hapur (Panchsheel Nagar)',
        'Hardoi',
        'Hathras',
        'Jalaun',
        'Jaunpur',
        'Jhansi',
        'Kannauj',
        'Kanpur Dehat',
        'Kanpur Nagar',
        'Kanshiram Nagar (Kasganj)',
        'Kaushambi',
        'Kushinagar (Padrauna)',
        'Lakhimpur - Kheri',
        'Lalitpur',
        'Lucknow',
        'Maharajganj',
        'Mahoba',
        'Mainpuri',
        'Mathura',
        'Mau',
        'Meerut',
        'Mirzapur',
        'Moradabad',
        'Muzaffarnagar',
        'Pilibhit',
        'Pratapgarh',
        'RaeBareli',
        'Rampur',
        'Saharanpur',
        'Sambhal (Bhim Nagar)',
        'Sant Kabir Nagar',
        'Shahjahanpur',
        'Shamali (Prabuddh Nagar)',
        'Shravasti',
        'Siddharth Nagar',
        'Sitapur',
        'Sonbhadra',
        'Sultanpur',
        'Unnao',
        'Varanasi',
    ],
    'West Bengal': [
        'Alipurduar',
        'Bankura',
        'Birbhum',
        'Cooch Behar',
        'Dakshin Dinajpur (South Dinajpur)',
        'Darjeeling',
        'Hooghly',
        'Howrah',
        'Jalpaiguri',
        'Jhargram',
        'Kalimpong',
        'Kolkata',
        'Malda',
        'Murshidabad',
        'Nadia',
        'North 24 Parganas',
        'Paschim Medinipur (West Medinipur)',
        'Purba Medinipur (East Medinipur)',
        'Purulia',
        'South 24 Parganas',
        'Uttar Dinajpur (North Dinajpur)',
    ],
};
